import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';

import * as style from './ModalPickFile.module.less';
import { Button } from 'react-bootstrap';
import { useState } from 'react';
import { useConfig } from '@assets/model/StoreConfig';

interface ModalFeedbackProps {}

export const ModalFeedback = observer((props: ModalFeedbackProps) => {
    return (
        <iframe
            style={{ width: '100%', height: '100%' }}
            src={useConfig().tally_url}
        ></iframe>
    );
});
